import { useCurrentStateAndParams } from '@uirouter/react';
import { Boxes } from 'lucide-react';

import { ResourcesTable } from '@/react/kubernetes/helm/release/ReleaseDetails/ResourcesTable/ResourcesTable';

import { useAddonReleaseScope } from './queries/useAddonReleaseScope';
import { useNamespaceResources } from './queries/useNamespaceResources';
import { AddonReleaseGuard } from './AddonReleaseGuard';

export function AddonResourcesTab() {
  const { params } = useCurrentStateAndParams();
  const id = String(params.id ?? '');
  const { scope, environmentId, namespace } = useAddonReleaseScope(id, {
    showResources: true,
  });
  const namespaceOnly = scope === 'namespaceOnly';

  // Without a release, fall back to the resources that exist in its namespace.
  const namespaceResourcesQuery = useNamespaceResources(
    environmentId ?? 0,
    namespace,
    { enabled: namespaceOnly }
  );

  return (
    <AddonReleaseGuard scope={scope}>
      <ResourcesTable
        environmentId={environmentId}
        name={id}
        namespace={namespace}
        resources={
          namespaceOnly ? (namespaceResourcesQuery.data ?? []) : undefined
        }
        isLoading={namespaceOnly && namespaceResourcesQuery.isLoading}
        standalone
        title="Resources"
        titleIcon={Boxes}
        withErrorNotification={false}
      />
    </AddonReleaseGuard>
  );
}
